import axios from "axios";
const API_URL = `${process.env.REACT_APP_API_URL}/settings`;

const listSettings = (): Promise<any> => {
  return axios.get(`${API_URL}/list-more-key`).then((response) => {
    return response;
  });
};

const createSettings = (data: any): Promise<any> => {
  return axios.post(`${API_URL}/add`, data).then((response) => {
    return response;
  });
};

const updateSettings = (id: any, data: any): Promise<any> => {
  return axios.put(`${API_URL}/edit/${id}`, data).then((response) => {
    return response;
  });
};

const viewSettings = (id: any): Promise<any> => {
  return axios.get(`${API_URL}/view/${id}`).then((response) => {
    return response.data;
  });
};
const updateSettingsKey = (id: any, data: any): Promise<any> => {
  return axios.put(`${API_URL}/edit-keys/${id}`, data).then((response) => {
    return response;
  });
};
const viewSettingsKey = (id: any): Promise<any> => {
  return axios.get(`${API_URL}/view-keys/${id}`).then((response) => {
    return response.data;
  });
};
const viewSettingsMore = (id: any): Promise<any> => {
  return axios.get(`${API_URL}/view-more/${id}`).then((response) => {
    return response.data;
  });
};
const deleteSettings = (id: any): Promise<any> => {
  return axios.put(`${API_URL}/delete/${id}`).then((response) => {
    return response.data;
  });
};

const getAppVersions = (): Promise<any> => {
  return axios.get(`${API_URL}/get-app-version`).then((response) => {
    return response.data;
  });
};

const getAppVersionById = (id: any) => {
  return axios.get(`${API_URL}/get-app-version`).then((response) => {
    const data = response.data?.data || response.data;
    if (Array.isArray(data)) {
      return data.find((item: any) => item.id.toString() === id.toString());
    }
    return data;
  });
};

const updateAppVersion = (id: any, data: any): Promise<any> => {
  return axios.put(`${API_URL}/update-app-version/${id}`, data).then((response) => {
    return response;
  });
};

const SMS_API_URL = `${process.env.REACT_APP_API_URL}/sms-settings`;

const listSMSSettingKeys = (): Promise<any> => {
  return axios.get(`${SMS_API_URL}/list`).then((response) => {
    return response;
  });
};

const createSMSSettingKey = (data: any): Promise<any> => {
  return axios.post(`${SMS_API_URL}/add`, data).then((response) => {
    return response;
  });
};

const updateSMSSettingKeyDetail = (id: any, data: any): Promise<any> => {
  return axios.put(`${SMS_API_URL}/edit/${id}`, data).then((response) => {
    return response;
  });
};

const viewSMSSettingKeyDetail = (id: any): Promise<any> => {
  return axios.get(`${SMS_API_URL}/view/${id}`).then((response) => {
    return response;
  });
};

const deleteSMSSettingKey = (id: any): Promise<any> => {
  return axios.put(`${SMS_API_URL}/delete/${id}`).then((response) => {
    return response;
  });
};

export {
  listSettings, createSettings, updateSettings, updateSettingsKey,
  viewSettings, viewSettingsKey, viewSettingsMore, deleteSettings,
  getAppVersions, getAppVersionById, updateAppVersion,
  listSMSSettingKeys, createSMSSettingKey, updateSMSSettingKeyDetail,
  viewSMSSettingKeyDetail, deleteSMSSettingKey
};
